import React, { useState } from "react";
import axios from "../../../utils/axiosInstance";
import { Hash, Plus, PencilSimple, Trash } from "@phosphor-icons/react";

export const ChannelBar = ({ channels, activeId, onSelect, isAdmin, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const active = channels.find((c) => c.id === activeId);

  const run = async (fn) => {
    setBusy(true);
    try { await fn(); await onChanged(); } catch (e) { alert("Błąd: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };
  const create = () => {
    const name = window.prompt("Nazwa nowego kanału (np. Pojazdy, Grafik):");
    if (!name?.trim()) return;
    run(async () => { const r = await axios.post("/api/chat/channels", { name }); onSelect(r.data.id); });
  };
  const rename = () => {
    const name = window.prompt("Nowa nazwa kanału:", active?.name || "");
    if (!name?.trim()) return;
    run(() => axios.patch(`/api/chat/channels/${activeId}`, { name }));
  };
  const remove = () => {
    if (!window.confirm(`Usunąć kanał „${active?.name}” razem ze wszystkimi wiadomościami?`)) return;
    run(async () => { await axios.delete(`/api/chat/channels/${activeId}`); onSelect("ogolny"); });
  };

  return (
    <div className="px-3 py-2 border-b border-border flex items-center gap-2" data-testid="chat-channel-bar">
      <div className="flex-1 flex gap-1.5 overflow-x-auto no-scrollbar">
        {channels.map((c) => {
          const on = c.id === activeId;
          return (
            <button
              key={c.id}
              onClick={() => onSelect(c.id)}
              className={`shrink-0 inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors ${
                on ? "bg-[#2563EB] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
              data-testid={`chat-channel-${c.id}`}
            >
              <Hash className="w-3.5 h-3.5" weight="bold" />
              {c.name}
              {!on && c.unread > 0 && (
                <span className="ml-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] leading-[18px] text-center" data-testid={`chat-channel-unread-${c.id}`}>
                  {c.unread > 99 ? "99+" : c.unread}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {isAdmin && (
        <div className="flex items-center gap-1 shrink-0">
          {active && !active.is_default && (
            <>
              <button onClick={rename} disabled={busy} title="Zmień nazwę kanału" className="p-1.5 rounded-md text-slate-500 hover:bg-slate-100" data-testid="chat-channel-rename">
                <PencilSimple className="w-4 h-4" />
              </button>
              <button onClick={remove} disabled={busy} title="Usuń kanał" className="p-1.5 rounded-md text-red-500 hover:bg-red-50" data-testid="chat-channel-delete">
                <Trash className="w-4 h-4" />
              </button>
            </>
          )}
          <button onClick={create} disabled={busy} title="Nowy kanał" className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100" data-testid="chat-channel-create">
            <Plus className="w-3.5 h-3.5" weight="bold" /> <span className="hidden sm:inline">Kanał</span>
          </button>
        </div>
      )}
    </div>
  );
};
